<template>
  <ObjectAddressCard :object="modelValue" :editable="editable" :onSave="onSave" />
</template>

<script>

import ObjectAddressCard from "@/components/cards/addressCards/ObjectAddressCard.vue";

export default {
  name: "CustomerAddressCard",
  components: {
    ObjectAddressCard,
  },
  props: {
    modelValue: {
      type: Object,
      required: false,
      default: null,
    },
    customerId: {
      type: Number,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  methods: {
    onSave(newAddress) {
      return new Promise((resolve, reject) => {
        this.$services.customer.patch(
          this.customerId,
          {
            address: newAddress,
          },
        ).then((response) => {
          this.$emit(
            "update:modelValue",
            response.data.address,
          );
          resolve();
        }).catch((error) => {
          if (error.response && error.response.status === 400) {
            error.response.data = error.response.data.address;
          }
          reject(error);
        });      
      });
    },
  },
};

</script>